module.exports = new __parcel__URL__("darkheal.469c6cc8.png").toString();